import {IconWrapperIconProps} from "app/Interface/Component/Icons"
import IconWrapper from "app/WebView/Component/icons/icon"
import React from "react"
import SettingsIconSvg from "static/icons/settings_black_24dp.svg"

const SettingsIcon = (props: IconWrapperIconProps) => {
  const name = 'settings'
  return (
    <IconWrapper name={name} {...props}>
      <SettingsIconSvg/>
    </IconWrapper>
  )
}

export default SettingsIcon
